// §0.5.6 Provider-Created Red Text Flags + §0.5.7 System-Generated Clinical Flags

export type SystemFlagType =
  | 'rhogam-due'
  | 'gbs-culture-due'
  // §J (Addendum June 2026): fired at ≥38w (266d) when no GBS result is on file.
  // Text: 'GBS collection window passed — no result on file. Document GBS status and management plan.'
  // Functions-side generation reads gbsPassedDays from settings/gbsConfig; update needed there separately.
  | 'gbs-window-passed'
  | 'glucose-screen-due'
  | 'missed-visit'
  | 'high-risk-alert'

export interface ProviderFlagDismissal {
  removedBy: string // userId
  removedAt: string // ISO timestamp
  reason: string
}

export interface ProviderFlag {
  patientId: string
  assessmentId: string
  practiceId: string
  text: string
  source: 'provider' | 'system'
  systemFlagType?: SystemFlagType
  addedBy: string // userId
  addedAt: string // ISO timestamp
  // Soft-delete — flag disappears from UI but is retained permanently
  removedBy?: string
  removedAt?: string
  removalReason?: string
  // Full dismissal history (system flags can be dismissed and re-generated repeatedly)
  dismissalHistory?: ProviderFlagDismissal[]
}

// §0.5.8 Provider Custom Color Dot Tags
export type ColorTagColor = 'red' | 'orange' | 'yellow' | 'green' | 'blue' | 'purple'

export const COLOR_TAG_COLORS: ColorTagColor[] = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
]

export const DEFAULT_COLOR_TAG_LABELS: Record<ColorTagColor, string> = {
  red: 'Urgent follow-up',
  orange: 'Awaiting outside results',
  yellow: 'Birth plan pending',
  green: 'Cleared for homebirth',
  blue: 'Consult scheduled',
  purple: 'Special circumstances',
}

export interface ProviderColorTagConfig {
  labels: Record<ColorTagColor, string>
}
